module.exports = __webpack_public_path__ + "static/media/ShowroomAcceIco_Selected.ebe954dd.svg";